export const WEBINAR_LINK_TEXT = 'Implementation Webinars'

export const WEBINAR_PATH = `/webinars`
